<template>
  <!-- A <button> can't contain the dismiss <button> below (invalid HTML, causes hydration mismatches); a
       div with role="button" reproduces native button semantics (click + Enter/Space activation) instead. -->
  <div
    role="button"
    tabindex="0"
    class="bg-app-secondary-10-white rounded-xl text-app-primary-1-red--fire-brick px-7 shadow-lg py-3 text-sm md:text-lg font-semibold flex items-center gap-5"
    :class="isVisible ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'"
    @click="open()"
    @keydown.enter="open()"
    @keydown.space.prevent="open()"
  >
    <span class="button-text-wrapper"> {{ data.settings.buttonLabel }}</span>
    <!-- .stop: without it, the click would also bubble to the outer div's @click="open()" (a .prevent-only
         modifier doesn't stop propagation), reopening the overlay it was just dismissed from. -->
    <button class="button-icon-wrapper" @click.stop.prevent="dismiss"><AtomIconCross style="color: #3e2b2e" /></button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  open: { type: Function, required: true },
  dismiss: { type: Function as PropType<() => void>, required: true },
  data: { type: Object as PropType<Record<string, any>>, required: true },
})

const overlayStore = useOverlayStore()
const isVisible = ref(false)
let displayDelayTimer: ReturnType<typeof setTimeout> | undefined

const showBanner = () => {
  if (!props.data?.settings) {
    isVisible.value = false
    return
  }

  if (props.data.settings.displayDelay > 0) {
    displayDelayTimer = setTimeout(() => {
      isVisible.value = true
    }, props.data.settings.displayDelay * 1000)
  } else {
    isVisible.value = true
  }
}

// Watch overlay.isDismissed store value to cancel the timer when the overlay was dismissed
watch(
  () => overlayStore.isDismissed,
  (isDismissedValue) => {
    if (displayDelayTimer && isDismissedValue === true) {
      clearTimeout(displayDelayTimer)
    }
  },
)

onMounted(() => {
  showBanner()
})
</script>

<style scoped lang="scss"></style>
